var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Icons / Bold / check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-130.000000, -995.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fill-color",
    transform: "translate(130.000000, 993.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.146,5.4 L20.354,2.6 C20.2601957,2.5059583 20.1328273,2.45310622 20,2.45310622 C19.8671727,2.45310622 19.7398043,2.5059583 19.646,2.6 L7.854,14.4 C7.76019574,14.4940417 7.63282726,14.5468938 7.5,14.5468938 C7.36717274,14.5468938 7.23980426,14.4940417 7.146,14.4 L4.354,11.6 C4.26019574,11.5059583 4.13282726,11.4531062 4,11.4531062 C3.86717274,11.4531062 3.73980426,11.5059583 3.646,11.6 L0.854,14.4 C0.658809031,14.5952499 0.658809031,14.9117501 0.854,15.107 L7.146,21.4 C7.23980426,21.4940417 7.36717274,21.5468938 7.5,21.5468938 C7.63282726,21.5468938 7.76019574,21.4940417 7.854,21.4 L23.146,6.1 C23.3365714,5.90557824 23.3365714,5.59442176 23.146,5.4 Z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.01d40ca18c80ded0508d60e92bc00535.svg";